/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { checkEnvironment } from '@saviynt/common';
import { Cookies } from 'react-cookie';

import { ERROR_MESSAGE } from '../../utils/constants';

/**
 * HttpService is a utility class for making HTTP requests.
 * It uses the Fetch API under the hood and provides methods
 * for setting, deleting, and resetting headers.
 *
 * This class is exported as both a singleton instance and a class.
 * You can import the singleton instance for shared use across the
 * application, or import the class to create a new instance.
 * For simple http calls, it's recommended to use the singleton instance.
 *
 * @example
 * // Importing the singleton instance:
 * import HttpServiceSingleton from 'HttpService';
 * When using the singleton, do not modify headers as this can affect other
 * calls that are using the shared instance while your modified call is in flight.
 *
 * // Importing the class to create a new instance:
 * import { HttpService } from 'HttpService';
 * const httpServiceObj = new HttpService();
 * httpServiceObj.deleteHeader('Content-Type');
 *
 * @export
 * @class HttpService
 */
export class HttpService {
  constructor() {
    this.cookies = new Cookies();
    this.initialHeaders = () => ({
      'Content-Type': 'application/json',
      ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
        Authorization: `${this.cookies.get('token_type')} ${this.cookies.get(
          'access_token'
        )}`,
      }),
    });
  }

  setHeaders(headers) {
    this.headers = {
      ...(this.headers || this.initialHeaders()),
      ...headers,
    };
  }

  deleteHeader(headerName) {
    this.headers = this.headers || this.initialHeaders();
    delete this.headers[headerName];
  }

  resetHeaders() {
    this.headers = this.initialHeaders();
  }

  get(url) {
    return fetch(url, {
      method: 'GET',
      headers: this.headers || this.initialHeaders(),
    })
      .then(async (res) => {
        if (res.status === 200) {
          return res.json();
        }

        // Extracting and sending error response from the api
        const error = await res.json();
        const response = res;

        response.error = error;
        response.errorMessage = error.errorMessage;

        return response;
      })
      .finally(() => {
        this.resetHeaders();
      });
  }

  post(url, req, errorCallback, shouldStringifyBody = true) {
    const body = shouldStringifyBody ? JSON.stringify(req) : req;

    return fetch(url, {
      method: 'POST',
      headers: this.headers || this.initialHeaders(),
      body,
    })
      .then(async (res) => {
        if (res.status === 200) {
          const contentType = res.headers.get('content-type');

          if (contentType?.includes('application/json')) {
            return res.json();
          }

          return res;
        }

        // Extracting and sending error response from the api
        const error = await res.json();
        const response = res;

        response.error = error;
        response.errorMessage = error.errorMessage;

        if (errorCallback && typeof errorCallback === 'function') {
          errorCallback();
        }

        return response;
      })
      .finally(() => {
        this.resetHeaders();
      });
  }

  put(url, req, errorCallback, shouldStringifyBody = true) {
    const body = shouldStringifyBody ? JSON.stringify(req) : req;

    return fetch(url, {
      method: 'PUT',
      headers: this.headers || this.initialHeaders(),
      body,
    })
      .then(async (res) => {
        if (res.status === 200) {
          const contentType = res.headers.get('content-type');

          if (contentType?.includes('application/json')) {
            return res.json();
          }

          return res;
        }

        // Extracting and sending error response from the api
        const error = await res.json();
        const response = res;

        response.error = error;
        response.errorMessage = error.errorMessage;

        if (errorCallback && typeof errorCallback === 'function') {
          errorCallback();
        }

        return response;
      })
      .finally(() => {
        this.resetHeaders();
      });
  }

  delete(url, req, errorCallback, shouldStringifyBody = true) {
    const body = shouldStringifyBody ? JSON.stringify(req) : req;

    // TODO: Enhance this when needed!
    return fetch(url, {
      method: 'DELETE',
      headers: this.headers || this.initialHeaders(),
      body,
    })
      .then(async (res) => {
        if (res.status === 200) {
          const contentType = res.headers.get('content-type');

          if (contentType?.includes('application/json')) {
            return res.json();
          }

          return res;
        }

        // Extracting and sending error response from the api
        const error = await res.json();
        const response = res;

        response.error = error;
        response.errorMessage = error.errorMessage ?? ERROR_MESSAGE;

        if (errorCallback && typeof errorCallback === 'function') {
          errorCallback();
        }

        return res;
      })
      .finally(() => {
        this.resetHeaders();
      });
  }
}

export default new HttpService();
